import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const state={   //要设置的全局访问的state对象
  atmenu: 1,
  atartical:1,
  title:'88888888'
  //要设置的初始属性值
};
const getters = {   //实时监听state值的变化(最新状态)
  getmenu(state) {  //方法名随意,主要是来承载变化的showFooter的值
    return state.atmenu
  },
  getChangedNum(state){  //方法名随意,主要是用来承载变化的changableNum的值
    return state.atartical
  },
  gettitle(state){
    return state.title
  }
};
const mutations = {
  mumenu(state,sum) {   //自定义改变state初始值的方法，这里面的参数除了state之外还可以再传额外的参数(变量或对象);
    state.atmenu = sum;
  },
  muartical(state,sum) {  //同上
    state.atartical = sum;
  },
  mutitle(state,title){
    state.title = title
  }
};
const actions = {
  acmenu(context,num) {
    context.commit('mumenu',num);
  },
  acartical(context,num){
    context.commit('muartical',num)
  },
  actitle(context,title){
    context.commit('mutitle',title)
  },
};
const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions
});
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js